import { styled } from 'styled-components';

export const ContentWarp = styled.div`
  width: 95%;
`;
export const OutletContentWarp = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
`;
